import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M17 4l0 16","key":"svg-0"}],["path",{"d":"M7 12l10 0","key":"svg-1"}],["path",{"d":"M7 4l0 16","key":"svg-2"}]]

/**
 * IconLetterH
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItbGV0dGVyLWgiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTE3IDRsMCAxNiIgLz4KICA8cGF0aCBkPSJNNyAxMmwxMCAwIiAvPgogIDxwYXRoIGQ9Ik03IDRsMCAxNiIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/letter-h
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconLetterH = createReactComponent('outline', 'letter-h', 'LetterH', __iconNode);

export default IconLetterH;